import {TFunction} from "i18next";
import {array, object, ObjectSchema, string} from "yup";
import {fieldDefinedError, fieldMin1Error} from "../../shared/technical/rest/validation";
import {getTranslatedValue, TranslatedValue, translatedValueSchema} from "../../shared/technical/i18n/TranslatedValue";
import {Application} from "../applications/Application";

export enum RoleType {
  STANDARD = 'STANDARD',
  RESTRICTED = 'RESTRICTED'
}

export const ROLE_TYPES: RoleType[] = Object.values(RoleType);

export interface Role {
  name: RoleName,
  type: RoleType,
  displayNames: TranslatedValue[]
}

export function roleSchema(t: TFunction): ObjectSchema<Role> {
  return object({
    name: string().defined(fieldDefinedError(t)),
    type: string().oneOf(ROLE_TYPES).default(RoleType.STANDARD).defined(fieldDefinedError(t)),
    displayNames: array(translatedValueSchema(t)).default([]).min(0, fieldMin1Error(t)),
  })
}

export enum StandardRole {
  USER = 'USER',
  ADMIN = 'ADMIN',
  APPLICATION_ADMIN = 'APPLICATION_ADMIN',
  COMPANY_ADMIN = "COMPANY_ADMIN"
}

export type RoleName = StandardRole | string;

export function formatRole(application: Application, roleName: RoleName) {
  const role = application.roles.find(curr => curr.name === roleName);
  if (!role) {
    return roleName
  }
  return getTranslatedValue(role.displayNames) || roleName
}
